import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowWall2Down: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-wall-2-down, align bottom"} maskId="square-filled-radius-0-stroke-1-IconArrowWall2Down"><path fillRule="evenodd" clipRule="evenodd" d="M12.5 3V18.2929L16.75 14.0429L17.4571 14.75L12.2071 20H20V21H4V20H11.7929L6.54289 14.75L7.25 14.0429L11.5 18.2929V3H12.5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowWall2Down;
